import { render, staticRenderFns } from "./invoice-item.vue?vue&type=template&id=56e31238&scoped=true"
import script from "./invoice-item.vue?vue&type=script&lang=js"
export * from "./invoice-item.vue?vue&type=script&lang=js"
import style0 from "./invoice-item.vue?vue&type=style&index=0&id=56e31238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e31238",
  null
  
)

export default component.exports